<template>
	<div>
		<!-- <mainHead :title="mainHeadTitle" @btnClick="addTableData" :hasPermiDict="hasPermiDict"></mainHead> -->
		<div class="mianPage">
			<div class="topSearch">
				<el-form inline class="el-form flex_start">
					<el-form-item>
						<el-date-picker v-model="queryData.submitDate" value-format="yyyy-MM-dd" format="yyyy-MM-dd" size="small"
						placeholder="选择日期">
						</el-date-picker>
					</el-form-item>
					<el-form-item>
						<el-select v-model="queryData.examineStatus" clearable size="small" style="width:210px" placeholder="审核状态">
							<el-option label="待审核" :value="2"></el-option>
							<el-option label="已通过" :value="3"></el-option>
							<!-- <el-option label="已驳回" :value="3"></el-option> -->
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-input clearable size="small" placeholder="公司名称" v-model="queryData.companyName"></el-input>
					</el-form-item>
					<div class="menu-right">
						<el-button @click="searchReset" size="small" v-hasPermi="['approvalPending:accountRegist:query']">重置</el-button>
						<el-button type="primary" @click="confirmQuery" size="small"
							v-hasPermi="['approvalPending:accountRegist:query']">查询</el-button>
					</div>
				</el-form>
			</div>
			<!-- table表格 -->
			<div class="tableBox">
				<!-- <div class="tableTopBtn space_between">
					<el-button type="primary" size="small" @click="addTableData">
						<i class="el-icon-plus"></i> 新增广告网络
					</el-button>
					<div @click="networkExport" class="exportBtn flex_center">
						<img src="../../assets/icon/export.png" alt="" />
						<div>导出</div>
					</div>
				</div> -->
				<el-table :max-height="600" :header-cell-style="{color:'#333333',background:'#EAEFF5'}" :data="tableData"
					class="el_table">
					<el-table-column prop="submitDate" label="日期"></el-table-column>
					<el-table-column prop="companyName" label="媒体公司名称"></el-table-column>
					<el-table-column prop="email" label="邮箱账号"></el-table-column>
					<el-table-column prop="password" label="账号密码"></el-table-column>
					<el-table-column prop="phone" label="手机号"></el-table-column>
					<el-table-column prop="" label="审核状态">
						<template slot-scope="scope">
							<div class="auditStatus" v-if="scope.row.examineStatus == 2">
								<div class="statusLabel"></div>
								<div>待审核</div>
							</div>
							<div class="auditStatus" v-else-if="scope.row.examineStatus == 3">
								<div class="statusLabel" style="background: #19B21E;"></div>
								<div>已通过</div>
							</div>
							<!-- <div class="auditStatus" v-else-if="scope.row.checkStatus == 3">
								<div class="statusLabel" style="background: #FC474C;"></div>
								<div>已驳回</div>
							</div> -->
						</template>
					</el-table-column>
					<el-table-column prop="" label="操作">
						<template slot-scope="scope">
							<div class="tableBtns flex_start">
								<el-button type="text" @click="examineTable(scope.row,3)" v-hasPermi="['approvalPending:accountRegist:approval']"
								:disabled="scope.row.examineStatus === 3">通过</el-button>
								<!-- <div class="splitLineTable"></div>
								<el-button type="text" @click="channelManage(scope.row)" v-hasPermi="['mediaManage:mediaManage:association']"
								:disabled="scope.row.status === 0">拒绝</el-button> -->
							</div>
						</template>
					</el-table-column>
				</el-table>
				<div class="paging" style="display: flex;justify-content: flex-end;margin-top: 20px;">
					<el-pagination @size-change="handleSizeChange" background @current-change="handleCurrentChange"
						:current-page="currentPage" :page-sizes="[10, 20, 30, 50]" :page-size="pageSize"
						layout="total, sizes, prev, pager, next, jumper" :total="total">
					</el-pagination>
				</div>
			</div>
		</div>
		<el-dialog :title="networkDialogTitle" :visible.sync="dialogVisible" width="28%">
			<el-form inline class="el-form el_dialog_form" label-width="120px" :rules="rulesApi" :model="networkFormData"
				ref="ruleForm">
				<el-form-item label="广告网络：" prop="platformId">
					<el-select v-model="networkSelectForm" clearable @change="networkSeleteChange" size="small"
						value-key="value">
						<el-option v-for="item in networkOptions" :key="item.value" :label="item.label" :value="item">
							<div class="selectTemp flex_start">
								<img :src="item.icon" alt="" />
								<div>{{item.label}}</div>
							</div>
						</el-option>
						<template #prefix>
						  <div class="checkedTemp flex_start" v-if="networkSelectForm.icon">
						  	<img :src="networkSelectForm.icon" alt="" />
						  </div>
						</template>
					</el-select>
				</el-form-item>
				<el-form-item label="账号名称：" prop="account">
					<el-input clearable size="small" placeholder="请输入" v-model="networkFormData.account"></el-input>
				</el-form-item>
				<el-form-item label="报表API状态：" prop="apiStatus">
					<el-radio v-model="networkFormData.apiStatus" :label="0">未开通</el-radio>
					<el-radio v-model="networkFormData.apiStatus" :label="1">已开通</el-radio>
				</el-form-item>
				<el-form-item label="Public Key：" prop="publicKey">
					<el-input clearable size="small" placeholder="请输入" v-model="networkFormData.publicKey"></el-input>
				</el-form-item>
				<el-form-item label="Secret Key：" prop="secretKey">
					<el-input clearable size="small" placeholder="请输入" v-model="networkFormData.secretKey"></el-input>
				</el-form-item>
				<div class="card-bottom flex_end">
					<el-button @click="closeDialog" size="medium">取消</el-button>
					<el-button type="primary" @click="confirmDialog('ruleForm')" size="medium">确定</el-button>
				</div>
			</el-form>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				queryData: {}, //列表查询条件
				companyOptions: [], // 公司下拉选择列表
				tableData: [],
				datePicker: [],
				currentPage: 1,
				pageSize: 10,
				total: 0,

				dialogVisible: false,
				networkOptions: [
					// {label: 'Sigmob',value: 'Sigmob',icon: require('../../assets/adsNetwork/Sigmob.png')}
				],
				rulesApi: {
					platformId: [{
						required: true,
						message: '请选择广告网络',
						trigger: 'blur'
					}],
					account: [{
						required: true,
						message: '请输入账号名称',
						trigger: 'blur'
					}]
				},
				networkFormData: {
					apiStatus: 0
				},
				networkDialogTitle: '新增广告网络',
				networkSelectForm: {}
			}
		},
		mounted() {
			// this.dateInit();
			// this.getCompanyOption();
			// this.getPlatformOption();
			this.getTableData();
		},
		methods: {
			// 日期选择器初始化
			dateInit() {
				let endDate = new Date();
				let startDate = new Date();
				// 结束日期设为昨天（不包含今天）
				endDate.setDate(endDate.getDate() - 1);
				// 开始日期设为7天前（总共7天范围）
				startDate.setDate(endDate.getDate() - 6);
				const formatDate = (date) => {
					return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
				};
				this.datePicker = [
					formatDate(startDate),
					formatDate(endDate)
				];
			},
			// 获取公司下拉列表
			async getCompanyOption() {
				let res = await this.$http.get(this.$api.common.companyOption);
				this.companyOptions = res.data
			},
			// 获取渠道下拉选择列表
			async getPlatformOption() {
				let res = await this.$http.get(this.$api.common.platformOption);
				this.networkOptions = res.data
			},
			async getTableData() {
				let data = {
					pageNum: this.currentPage,
					pageSize: this.pageSize
				}
				data = {
					...data,
					...this.queryData
				}
				let res = await this.$http.post(this.$api.approval.companyRegisterList, data);
				if(res.code == 1){
					this.tableData = res.data.list
					this.total = res.data.totalRecord
				}
			},
			handleSizeChange(val) {
				this.currentPage = 1
				this.pageSize = val
				this.getTableData();
			},
			handleCurrentChange(val) {
				this.currentPage = val
				this.getTableData();
			},
			searchReset() {
				this.currentPage = 1
				this.queryData = {
					platformId: '',
					apiStatus: '',
				}
				this.getTableData();
			},
			confirmQuery() {
				this.currentPage = 1
				this.getTableData();
			},
			addTableData() {
				this.networkFormData = {
					apiStatus: 0
				},
				this.networkDialogTitle = '新增广告网络'
				this.dialogVisible = true
			},
			examineTable(row,type) {
				this.$confirm('该账号审核状态改为已通过, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'info'
				}).then(async () => {
					let data = {
						examineStatus: type,
						id: row.id
					}
					let res = await this.$http.post(this.$api.approval.companyRegisterExamine, data);
					if(res.code == 1){
						this.$message.success('审批完成');
						this.getTableData();
					}
				}).catch(() => {
				});
			},
			networkSeleteChange(e) {
				// console.log(e);
				this.networkFormData.platformId = e.value
				this.networkSelectForm = e
				// console.log(this.networkSelectForm)
			},
			closeDialog() {
				this.dialogVisible = false
			},
			confirmDialog(formName) {
				this.$refs[formName].validate(async (valid) => {
					if (valid) {
						let data = this.networkFormData;
						if (this.datePicker.length > 0) {
							data['startDate'] = this.datePicker[0]
							data['endDate'] = this.datePicker[1]
						}
						let res = await this.$http.post(this.$api.mediaAd.networkSave, data);
						if (res.code == 1) {
							if (data.id) {
								this.$message.success('修改成功');
							} else {
								this.$message.success('新增成功');
							}
						}
						this.closeDialog();
						this.getTableData();
					}
				});
			},
			// 导出
			async networkExport() {
				let data = {
					pageNum: this.currentPage,
					pageSize: this.pageSize
				}
				if (this.datePicker && this.datePicker.length > 0) {
					data.startDate = this.datePicker[0];
					data.endDate = this.datePicker[1];
				}
				data = {
					...data,
					...this.queryData
				}
				let res = await this.$http.post(this.$api.mediaAd.networkListExport, data, 1);
				const time = this.getTimeFun();
				this.$http.downloads(res, `${time}广告网络.xls`)
			},
			// 下载选择的日期
			getTimeFun() {
				if (!this.datePicker || !this.datePicker.length) {
					return ''
				}
				var startMonth = this.datePicker[0];
				var endMonth = this.datePicker[1];
				// 如果开始时间和结束时间相同，则以开始时间为主
				if (startMonth === endMonth) {
					endMonth = ''
				};
				return startMonth + "-" + endMonth;
			},
		},
	}
</script>

<style scoped>
	.mianPage {
		padding: 10px;
	}

	.topSearch {
		background: #ffffff;
		padding: 16px;
		padding-bottom: 6px;
	}

	.el-form {}

	/deep/ .el-form-item {
		margin-right: 10px !important;
		margin-bottom: 10px;
	}

	.tableTopBtn {
		margin-bottom: 16px;
		align-items: center;
	}

	.exportBtn {
		border: 1px solid #D9D9D9;
		box-sizing: border-box;
		align-items: center;
		height: 32px;
		width: 80px;
		font-size: 14px;
		color: #333;
		border-radius: 2px;
		cursor: pointer;
	}

	.exportBtn img {
		width: 16px;
		height: 16px;
		margin-right: 4px;
	}

	.tableBox {
		margin-top: 10px;
		background: #ffffff;
		padding: 16px;
	}

	.menu-right {
		margin-left: auto;
	}

	.el_dialog_form /deep/ .el-form-item {
		margin-right: 0;
	}


	.businessLicenseTips {
		width: 120px;
		height: 120px;
		border-radius: 4px;
		border: 1px solid #DBDFE3;
		box-sizing: border-box;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.businessLicenseTips img {
		width: 56px;
		height: 56px;
	}

	.businessLicenseImg {
		width: 120px;
		height: 120px;
	}

	.selectTemp,
	.checkedTemp {
		align-items: center;
		width: 100%;
		font-weight: 500;
		font-size: 14px;
		color: #333333;
	}

	.selectTemp img,
	.checkedTemp img {
		width: 24px;
		height: 24px;
		margin-right: 4px;
	}

	.checkedTemp {
		height: 32px;
		margin-top: 4px;
	}
	
	.auditStatus {
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	
	.statusLabel {
		width: 6px;
		height: 6px;
		border-radius: 50%;
		margin-right: 4px;
		background: #FA9600;
	}
	
	.tableBtns{
		align-items: center;
	}
	.splitLineTable{
		width: 1px;
		height: 12px;
		background-color: #DEDEDE;
		margin: 0 12px;
	}
</style>